import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { Nav } from "../components/landing/Nav";
import { Hero } from "../components/landing/Hero";
import { Marquee } from "../components/landing/Marquee";
import { Bento } from "../components/landing/Bento";
import { Sides } from "../components/landing/Sides";
import { Steps, FinalCta, Footer } from "../components/landing/Closing";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: { offset: -70 } });
    let id = 0;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  return (
    <div className="grain relative bg-[#0A0E1A] text-slate-100" data-testid="landing-page">
      <Nav />
      <Hero />
      <Marquee />
      <Bento />
      <Sides />
      <Steps />
      <FinalCta />
      <Footer />
    </div>
  );
}
